import { v4 as uuidv4 } from 'uuid';
import { SIGN_UP_URL } from '../flows/login/constants';
import { ICategory, IServerErrorResponse, ITransaction } from '../types';
import { SERVER_ERRORS } from '../constants/serverErrors';
import { LOGIN_ERRORS } from '../flows/login/constants/messages';
import { ASSETS_BASE_URL } from '../constants/endpoints';

export const getClientId = () => (
  process.env.REACT_APP_NODE_ENV
   === 'production' ? process.env.REACT_APP_CLIENT_ID_PROD : process.env.REACT_APP_CLIENT_ID_DEV
);

export const handleApplyToLili = () => {
  window.open(SIGN_UP_URL, '_self');
};

const serverErrorCode = /5[0-9][0-9]/;

// TODO muli please review this
export const extractErrorFromCode = (errorResponse?: IServerErrorResponse | null) => {
  if (!errorResponse) {
    return '';
  }
  if (errorResponse.response.status && serverErrorCode.test(errorResponse.response.status.toString())) return LOGIN_ERRORS.BAD_REQUEST;

  const { response: { data } } = errorResponse;
  return SERVER_ERRORS[data?.errors?.[0]?.code] ?? data?.errors?.[0]?.message ?? LOGIN_ERRORS.BAD_REQUEST;
};

export const getCategoryImage = (currentTransaction: ITransaction, transactionsCategories: ICategory[], setter: any) => {
  if (!currentTransaction) return;
  const currentCategory = transactionsCategories?.find((category: any) => category.id === currentTransaction.suggestedTaxCategoryId);
  const image = `${ASSETS_BASE_URL}/unified/categories/svg/56/${currentCategory?.imageName ?? 'Other'}.svg`;
  const title = currentCategory?.imageName || 'OTHER EXPENSES';
  setter({ image, title });
};

export const getCategoryImageTitleObject = (currentTransaction: ITransaction | undefined, transactionsCategories: ICategory[]) => {
  if (!currentTransaction || !transactionsCategories) return null;
  const currentCategory = transactionsCategories?.find((category: any) => category.id === currentTransaction.suggestedTaxCategoryId);
  const image = `${ASSETS_BASE_URL}/unified/categories/svg/56/${currentCategory?.imageName ?? 'Other'}.svg`;
  const title = currentCategory?.imageName || 'OTHER EXPENSES';
  return { image, title };
};

export const generateRandomId = () => uuidv4();

export const getCookie = (cname: string) => {
  const name = `${cname}=`;
  let decodedCookie;
  try {
    decodedCookie = decodeURIComponent(document.cookie);
  } catch (e) {
    return '';
  }
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};

export const setCookie = (cname: string, cvalue: string, exdays: number, isLiliDomain: boolean = false) => {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  const expires = `expires=${d.toUTCString()}`;
  document.cookie = `${cname}=${cvalue};${expires};${isLiliDomain ? 'domain=.lili.co' : ''};path=/`;
};

export const hasOverflowYContent = (el: HTMLElement) => el.scrollHeight > el.clientHeight;
